import { Observable } from 'rxjs'
import { SystemNotification } from 'types/definitions'
import { map } from 'rxjs/operators'
import Notification from './models/Notification'

/**
 * Maps a stream of notifications to a stream of system notifications.
 *
 * @param notification$
 * @param navigate
 */
export function NotificationsToSystemNotifications(
  notification$: Observable<Notification>,
  navigate: (url: string) => unknown,
): Observable<SystemNotification> {
  return notification$.pipe(
    map(
      (x): SystemNotification => ({
        title: x.recipient.workspace.name,
        body: x.plainText,
        tag: x.id || '',
        icon: x.imageUrl || undefined,
        onClick: () => (x.actionUrl ? navigate(x.actionUrl) : undefined),
      }),
    ),
  )
}
